<p-colorPicker [(ngModel)]="selectedColor" (onChange)="feedback()" [inline]="isInLine" [appendTo]="parentToAppend"></p-colorPicker>
